export default "__VITE_ASSET__Dj5rsm0T__"